import React from 'react'
import { useTranslation } from 'next-i18next'
import DynamicHeroIcon from './DynamicHeroIcon'
import { useRouter } from 'next/router'
import Link from 'next/link'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLElement> {
    className?: string
}

const classes = {
    base: 'flex font-medium text-sm text-center w-fit cursor-pointer',
}

const BackButton: React.FC<ButtonProps> = ({ className, ...restProps }) => {
    const { t } = useTranslation(['common'])
    const router = useRouter()

    const finalSlashIndex = router.asPath.lastIndexOf('/')
    let previousPath = router.asPath.slice(0, finalSlashIndex)

    let pathName = ''
    if (previousPath === '/opleidingsaanbod') {
        pathName = t('back-to-trainings')
    } else {
        previousPath = '/'
        pathName = t('back-to-start')
    }

    return (
        <Link href={previousPath}>
            <a
                className={`
				${classes.base}
				${className}
			`}
                {...restProps}
            >
                <DynamicHeroIcon icon="ChevronLeftIcon" className="w-5 h-5" aria-hidden="true" />
                <span>{pathName}</span>
            </a>
        </Link>
    )
}

export default BackButton
